<template>
  <div>
    <el-form ref="relevantApp" :inline="true" :model="relevantApp"
      label-width="200px" size="small"
      :style="{ backgroundColor: backgroundColor }">
      <el-form-item label="Τύπος αίτησης">
        {{ applicationTypeDescription(relevantApp.applicationType) }}
      </el-form-item>
      <el-form-item label="Τύπος τίτλου" v-if="!isRelevantReappraisal">
        {{ translate(relevantApp.degreeType) }}
      </el-form-item>
      <el-form-item v-if="relevantApp.degreeType === 'bachelor'">
        {{ relevantApp.consideration ? 'με Συνυποβολή' : 'χωρίς Συνυποβολή' }}
        {{ relevantApp.correspondence ? ' / με Αντιστοίχιση' : ' / χωρίς Αντιστοίχιση' }}
      </el-form-item>
      <br />
      <el-form-item label="Αριθμός αίτησης">
        {{ relevantApp.id }}
      </el-form-item>
      <el-form-item label="Αριθμός Πρωτοκόλλου">
        {{ relevantApp.protocol }}
      </el-form-item>
      <el-form-item label="Αριθμός Πράξης">
        {{ relevantApp.praxeisNo }}
      </el-form-item>
      <br />
      <el-form-item label="Απόφαση Προέδρου">
        {{ decisionDescription(relevantApp.decision_id) }}
      </el-form-item>
      <titles v-if="!isRelevantReappraisal"
        :application="relevantApp">
      </titles>
      <hr />
      <p style="margin-left: 15px; margin-top: 15px; margin-bottom: 15px;">
        <b>Επισυναπτόμενα Αρχικής Αίτησης</b>
      </p>
      <attached-documents :attachedDocumentsTable="attachedDocumentsTable"
        :neededDocuments="relevantApp.neededDocuments"
        :appId="relevantApp.id">
      </attached-documents>
    </el-form>
    <!-- Επιπλέον περιεχόμενο όταν isRelevantReappraisal === true -->
    <template v-if="isRelevantReappraisal && relevantApp.relevantApplication">
      <div class="relevant-app-title">
        <h3><b>Σχετική αίτηση της Αίτησης Επανεξέτασης: {{ relevantApp.id }}</b></h3>
      </div>
      <!-- Recursive call - δεύτερο relevant app -->
      <relevant-app
        :relevantApp="relevantApp.relevantApplication"
        backgroundColor="#f7f7f7"
        class="relevant-app-style">
      </relevant-app>
    </template>
  </div>
</template>
<script>
// import axios from 'axios'
import { mapGetters, mapState } from 'vuex'
import dictionary from '../../store/dictionary'
import Titles from './Titles'
import AttachedDocuments from './AttachedDocuments'
export default {
  name: 'RelevantApp',
  // props: [ 'relevantApp' ],
  props: {
    relevantApp: {
      type: Object,
      required: true
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    }
  },
  components: {
    Titles,
    AttachedDocuments
  },
  data () {
    return {
    }
  },
  mounted () {
    if (!Array.isArray(this.presidentDecisions) || this.presidentDecisions.length === 0) {
      this.getDecisions()
    }
  },
  methods: {
    getDecisions () {
      this.$store.dispatch('LOAD_PRESIDENT_DECISIONS')
    },
    decisionDescription (decisionId) {
      const decision = this.presidentDecisions.find(d => d.id === decisionId)
      return decision ? decision.decision_text : '---'
    },
    translate (term) {
      return dictionary[term]
    },
    applicationTypeDescription (appType) {
      switch (appType) {
        case 'recognition':
          return 'Αναγνώριση'
        case 'reappraisal':
          return 'Επανεξέταση'
        case 'compensatory':
          return 'Έκδοση Πράξης μετά από εξετάσεις'
      }
      return '---'
    }
  },
  computed: {
    isRelevantReappraisal () {
      return this.relevantApp.applicationType === 'reappraisal'
    },
    attachedDocumentsTable () {
      return this.relevantApp.attachedDocuments.slice(0).map(doc =>
        ({name: doc.name,
          type: doc.type,
          date: doc.date,
          applicantComment: doc.applicantComment,
          precheckerChecked: doc.precheckerChecked,
          precheckerComment: doc.precheckerComment,
          id: doc.id
        })
      )
    },
    idOrPassport () {
      return this.personalDetails.id.idCardOrPassport ? 'Ταυτότητα' : 'Διαβατήριο'
    },
    birthCountryName () {
      let country = this.countries.find(item => item.id === this.personalDetails.birthCountryId)
      return country !== undefined ? country.name : ''
    },
    countryName () {
      let country = this.countries.find(item => item.id === this.personalDetails.countryId)
      return country !== undefined ? country.name : ''
    },
    ...mapGetters([ 'activeRole' ]),
    ...mapState([
      'countries',
      'presidentDecisions'
    ])
  }
}
</script>

<style scoped lang="scss">
.el-form-item {
  color: rgb(30, 0, 128);
  font-weight: bold;
  // border-radius: 10px;
  // border-style: solid;
  // border-color: #7fa3bb green #86b8da yellow;
  // border-width: 0px 0px 2px 0px;
  // padding-right: 20px;
}
hr {
  border-color: #7da0b8;
}
.relevant-app-title {
  background-color: lightgrey;
  padding: 10px;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 3px;
}
.relevant-app-style {
  border: 2px solid #7da0b8;
  padding: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/RelevantApp.vue